import React from "react";
import PropTypes from "prop-types";

const AdobeDynamicTagManager = ({ dtm_url }) => (
    <>
        {/* 😐 jquery is needed for dtm */}
        <script type="text/javascript" src="//ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js" />
        <script src={dtm_url} type="text/javascript" />
        <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
                __html: `if (typeof _satellite != 'undefined') {
                            _satellite.pageBottom();
                        }`
            }}
        />
    </>
);

AdobeDynamicTagManager.propTypes = {
    dtm_url: PropTypes.string.isRequired
};

export default AdobeDynamicTagManager;
